import React from 'react';
import { Check, Minus, Loader2 } from 'lucide-react';

/**
 * Celda de la matriz de completitud.
 *
 * `estado`: 'ok' | 'faltante' | 'no_aplica' | 'loading'
 * En modo rango (`diasEsperados > 1`) muestra la fracción de días cubiertos en
 * lugar del simple listo/pendiente.
 */
const StatusCell = ({ estado, diasConRegistro = 0, diasEsperados = 1, registros = 0 }) => {
  if (estado === 'no_aplica') {
    return (
      <span className="text-xs text-muted-foreground/40 select-none" title="No aplica a este centro">
        —
      </span>
    );
  }

  if (estado === 'loading') {
    return <Loader2 className="h-4 w-4 animate-spin text-muted-foreground mx-auto" />;
  }

  const esRango = diasEsperados > 1;

  if (esRango) {
    const pct = diasEsperados > 0 ? (diasConRegistro / diasEsperados) * 100 : 0;
    const completo = diasConRegistro === diasEsperados;
    return (
      <div className="flex flex-col items-center gap-1" title={`${registros} registro(s) en el rango`}>
        <span
          className={`text-sm font-semibold tabular-nums ${
            completo ? 'text-foreground' : 'text-muted-foreground'
          }`}
        >
          {diasConRegistro}/{diasEsperados}
        </span>
        <div className="w-14 h-1 rounded-full bg-muted overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ${
              completo ? 'bg-emerald-500' : pct > 0 ? 'bg-amber-500' : 'bg-red-500/70'
            }`}
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    );
  }

  if (estado === 'ok') {
    return (
      <div className="flex flex-col items-center gap-0.5" title={`${registros} registro(s)`}>
        <Check className="h-5 w-5 text-emerald-600 dark:text-emerald-400" strokeWidth={2.5} />
        <span className="text-xs text-muted-foreground">{registros}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-0.5">
      <Minus className="h-5 w-5 text-red-500/70" strokeWidth={2} />
      <span className="text-xs text-muted-foreground/70">Pendiente</span>
    </div>
  );
};

export default StatusCell;
